import React from 'react';

const project1 = () => {
    return (
        <div>
            <h1>Sign In Page</h1>
        </div>
    );
};

export default project1;
